import '../../onboarding.styles.css';
import AccordionContentLayout from '../AccordionContentLayout';
import { showTypedModal } from '@/common/common_utils';
import AddBillingInfoModal from '@/modules/billing/billing-information/AddBillingInfoModal';
import { TextBodyMedium, TextLabelLarge2 } from '@/components/text/Texts';
import { Button } from 'primereact/button';
import { cn } from '@/components/ui/cn';
import { MdArrowForward } from 'react-icons/md';
import { Column } from '@/components/container/Container';

const ProvideBillingInfoContent = ({ isFinished }: { isFinished: boolean }) => (
	<AccordionContentLayout>
		<Column className="px-11 py-2 gap-6">
			<TextBodyMedium
				className="font-poppins tracking-[0.25px]"
				text={isFinished
					? 'Billing details have been successfully recorded'
					: 'Enter your billing information securely to ensure smooth transactions within Xpress for Business'
				}
			/>
			<Button
				className={cn('self-start h-12 pl-6 gap-2 rounded-[100px]', isFinished ? 'pr-6 bg-secondaryContainer' : 'pr-4 bg-primary')}
				onClick={async () => await showTypedModal(AddBillingInfoModal, {})}
			>
				<TextLabelLarge2
					text={isFinished ? 'Change Billing Information' : 'Start'}
					className={isFinished ? 'text-secondary' : 'text-white'}
				/>
				{!isFinished && (<MdArrowForward size={18} className="text-white" />)}
			</Button>
		</Column>
	</AccordionContentLayout>
);

export default ProvideBillingInfoContent;
